import { css } from "@emotion/css";
import type { Properties } from "signlets";

const style = css`
  margin: 0;
`;

export const H1 = ({ children }: Properties<{ children: JSX.Element }>) => (
  <h1 class={style}>{children}</h1>
);
